import { environment } from 'src/environments/environment';

/**
 * Constantes de rutas para autenticación
 */
export const AUTH_ROUTES = {
  LOGIN: '/login',
  HOME: '/operational-staff',
  LOGOUT_REDIRECT: '/',
} as const;

/**
 * Configuración de autenticación
 */
export const AUTH_CONFIG = {
  SCOPES: environment.auth.scopes,
  TOKEN_REUSE_WINDOW_MS: environment.auth.tokenReuseMinutes * 60 * 1000,
  SILENT_RENEWAL_TIMEOUT_MS: environment.auth.silentRenewalTimeoutMs,
} as const;
